export const restApiPostsOffers = async (err) => {
  if (err) {
    console.error(err);
  }
  const offersPostsContainer = document.querySelector('.rest-api-offers-list'),
    blogId = document.getElementsByTagName('html')[0].id;
  var blogName = '';

  if (blogId) {
    if (blogId === 'blog-4') {
      blogName = 'kronechurwalden';
    }
    if (blogId === 'blog-5') {
      blogName = 'pradaschier';
    }
    if (blogId === 'blog-6') {
      blogName = 'lenzerhorn';
    }
    if (blogId === 'blog-7') {
      blogName = 'posthotelvalbella';
    }
    if (blogId === 'blog-8') {
      blogName = 'swissheidihotel';
    }
    if (blogId === 'blog-9') {
      blogName = 'heid360';
    }
  } else {
    blogName = '';
  }

  const currentUrl = window.location.href;
  const getSubdomain = (url) => {
    let domain = url;
    if (url.includes('://')) {
      domain = url.split('://')[1];
    }
    const subdomain = domain.split('.')[0];
    return subdomain;
  };

  if (offersPostsContainer) {
    // check if production or staging environment
    if (
      getSubdomain(currentUrl) != 'new' &&
      getSubdomain(currentUrl) != 'alpintrend'
    ) {
      addPostsChunk(
        'https://' + window.location.hostname + '/wp-json/offers/all-posts',
        true,
        0,
        offersPostsContainer,
      );
    } else {
      addPostsChunk(
        '/' + blogName + '/wp-json/offers/all-posts',
        true,
        0,
        offersPostsContainer,
      );
    }
  }

  function addPostsChunk(
    restApiUrl,
    replaceCurList = false,
    count = 0,
    offersPostsContainer,
  ) {
    //
    // load more api call - get the current chunk of posts from the REST API
    //

    let postsShown = 3;

    fetch(restApiUrl)
      .then((response) => response.json())
      .then((data) => {
        // If filter is clicked, start output with first post
        // If more button is clicked, start output with the next chunk
        if (replaceCurList) {
          data.splice(0, 0);
        } else {
          data.splice(0, postsShown);
        }

        const newData = chunkArray(data, postsShown),
          currentChunk = newData[count];

        if (count <= newData.length) {
          const items = [];

          items.push(
            `<div class="wp-block-columns is-layout-flex wp-block-columns-is-layout-flex">`,
          );

          currentChunk.forEach((key, index) => {
            const postTitle = currentChunk[index].title,
              postImg = currentChunk[index].featured_img_src,
              postUrl = currentChunk[index].current_url,
              slideContents = `
                <div class="wp-block-column is-layout-flow wp-block-column-is-layout-flow">
                    <h4 class="wp-block-heading">${postTitle}</h4>
                    <div class="wp-block-cover">
                        ${postImg}
                        <span aria-hidden="true" class="wp-block-cover__background has-background-dim-0 has-background-dim"></span>
                        <div class="wp-block-cover__inner-container is-layout-flow wp-block-cover-is-layout-flow">
                            <div class="wp-block-buttons is-content-justification-center is-layout-flex wp-block-buttons-is-layout-flex">
                                <div class="wp-block-button is-style-default">
                                    <a class="wp-block-button__link wp-element-button" href="${postUrl}">Mehr erfahren</a></div>
                            </div>
                        </div>
                    </div>
                </div>`;

            items.push(slideContents);
          });

          items.push(
            `<div class="wp-block-column is-layout-flow wp-block-column-is-layout-flow"> <div class="wp-block-buttons is-layout-flex wp-block-buttons-is-layout-flex"> <div class="wp-block-button is-style-nobg-border-link"><a class="wp-block-button__link wp-element-button" href="/${blogName}/hotel/packages/">Alle Angebote</a></div> </div> </div></div>`,
          );

          // If filter is clicked, start output with first post
          // If more button is clicked, start output with the next chunk
          if (replaceCurList) {
            offersPostsContainer.innerHTML = items.join('');
          } else {
            offersPostsContainer.insertAdjacentHTML(
              'beforeend',
              items.join(''),
            );
          }
        }
      })
      .catch((err) => {
        console.log('Something went wrong!', err);
      });
  }

  function chunkArray(array, size) {
    const chunkyArr = [];
    let index = 0;
    while (index < array.length) {
      chunkyArr.push(array.slice(index, size + index));
      index += size;
    }

    return chunkyArr;
  }
};

import.meta.webpackHot?.accept(restApiPostsOffers);
